







import {Component, Vue, Prop} from "vue-property-decorator";
import Attribute from "@/api/Product/Attribute";

@Component
export default class RenderProductAttributeText extends Vue {
  @Prop() private attribute!: Attribute;
}
